import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-beige overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12" data-id="element-201">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="flex flex-col items-center text-center" data-id="element-203">
          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-charcoal leading-tight mb-6 max-w-4xl" data-id="element-204">
            Tu casa merece las mejores decisiones.
            <br data-id="element-205" />
            <span className="text-gold" data-id="element-206">Empezá por acá.</span>
          </h1>

          {/* CTA Button */}
          <div className="w-full sm:w-auto mb-4" data-id="element-207">
            <a href="#precios" className="block w-full sm:w-auto text-center bg-terracotta hover:bg-terracotta-light text-white font-bold py-4 px-8 rounded shadow-md hover:shadow-lg transition-all text-base md:text-lg" data-id="element-208">
              → ACCEDER AHORA
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600 mb-12" data-id="element-209">
            <div className="flex items-center gap-1.5" data-id="element-210">
              <Shield className="w-4 h-4 text-gold" data-id="element-211" />
              <span data-id="element-212">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-213">
              <Lock className="w-4 h-4 text-gold" data-id="element-214" />
              <span data-id="element-215">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-216">
              <CreditCard className="w-4 h-4 text-gold" data-id="element-217" />
              <span data-id="element-218">Mercado Pago</span>
            </div>
            <div className="flex items-center gap-1.5 font-medium" data-id="element-219">
              <span className="text-gold" data-id="element-220">★</span>
              <span data-id="element-221">+1.200 propietarios</span>
            </div>
          </div>

          {/* Image */}
          <div className="relative w-full max-w-3xl mx-auto" data-id="element-222">
            <div className="absolute inset-0 bg-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-223"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gcEofi79xC4PjNSraaKL7N/MockUp_MegaPack_Arquitectura_Argentina_sin_fondo.png" alt="Colección Arquitectura Argentina - Zentral Pro" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" loading="eager" fetchPriority="high" decoding="async" data-id="element-224" />
          </div>
        </div>
      </div>
    </section>;
}